import assign = require('object-assign');
import { Promise } from 'es6-promise';

import { Authentication } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

interface IMeState {
    userId: string
}

function fetchMe(requesterId: string, query): Promise<IMeState> {
    return request.get(`auth/authenticated`, query);
}

export function getMe(requesterId: string, apiKey: string): any {
    return dispatch => {
        dispatch(new FSA(Authentication.FETCH_REQUEST).addMeta({ requesterId }).data);

        return fetchMe(requesterId, { apiKey }).then(me => {
            return dispatch(new FSA(Authentication.FETCH_SUCCESS).addPayload(me).addMeta({ requesterId, apiKey }).data);
        }, err => {
            dispatch(new FSA(Authentication.FETCH_FAILURE).addError(err).addMeta({ requesterId, apiKey }).data);
            throw err;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/Authentication.ts